<template lang="pug">
md-input-container(:class='{"md-input-invalid" : showRequiredError,"input-container": multiple }')
    label {{ multiple ? 'Playlists' : 'Playlist' }}
    md-select(:multiple='multiple', v-model='selected', @selected='onPlaylistSelected', :disabled='playLists.length === 0')
      md-option(v-for='playList in playLists',:key="playList._id" :value='playList._id') {{ playList.name }}
    span.md-error(v-show='showRequiredError') This field is required
</template>

<script>
  import playlistService from '../../services/playlistService';

  export default {
    props: {
      value: {
        type: [String, Array],
        default: ''
      },
      multiple: {
        type: Boolean,
        default: false
      },
      showRequiredError: {
        type: Boolean,
        default: false
      },
      justPublicStatus: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selected: this.value,
        playLists: []
      };
    },
    methods: {
      onPlaylistSelected(value) {
        this.$emit('selectedPlayList', this.playLists.find(playList => playList._id === value));
        this.$emit('input', value);
      },
      getPlayLists() {
        const params = { limit: 100, sortBy: 'name', sortOrder: 'asc' };
        if(this.justPublicStatus) {
          params.status = 'public';
        }
        playlistService.getList(params)
          .then((response) => {
            this.playLists = response.data.playlists;
          })
          .catch(() => {
            this.$emit('getNetworksError');
          });
      },
      reload() {
        this.getPlayLists();
      }
    },
    mounted() {
      this.getPlayLists();
    },
    watch: {
      value(newValue) {
        if(this.multiple){
          this.selected = Array.isArray(newValue) ? newValue : [];
        }
        if(!this.multiple){
          this.selected = ''
          setTimeout(() => {
            this.selected = newValue;
          }, 1500);
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
.input-container{
  max-width: 50em;
}
</style>


// WEBPACK FOOTER //
// src/shared-components/playlist/PlaylistSelector.vue